import _Promise from 'babel-runtime/core-js/promise';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import { loginAPI, logoutAPI } from '@/api/login';
import { adminIndexAuthListAPI } from '@/api/common';
import { resetRouter } from '@/router';

import { adminUsersReadAPI } from '@/api/user/personCenter';

import { addAuth, removeAuth } from '@/utils/auth';
import { request } from '@/utils';
import Lockr from 'lockr';

var user = {
  state: {
    userInfo: null, // 用户信息
    // 权限信息
    allAuth: null, // 总权限信息 默认空 调整动态路由
    crm: {}, // 客户管理
    bi: {}, // 商业智能
    manage: {}, // 管理后台
    oa: {}, // 办公
    project: {} // 项目管理
  },

  mutations: {
    SET_USERINFO: function SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem('loginUserInfo', _JSON$stringify(userInfo));
    },
    SET_ALLAUTH: function SET_ALLAUTH(state, allAuth) {
      state.allAuth = allAuth;
    },
    SET_CRM: function SET_CRM(state, crm) {
      state.crm = crm;
    },
    SET_BI: function SET_BI(state, bi) {
      state.bi = bi;
    },
    SET_MANAGE: function SET_MANAGE(state, manage) {
      state.manage = manage;
    },
    SET_OA: function SET_OA(state, oa) {
      state.oa = oa;
    },
    SET_PROJECT: function SET_PROJECT(state, project) {
      state.project = project;
    },
    SET_AUTH: function SET_AUTH(state, data) {
      var token = data.authKey;
      var sessionId = data.sessionId;
      Lockr.set('authKey', token);
      Lockr.set('sessionId', sessionId);
      addAuth(token, sessionId);
    }
  },

  actions: {
    // 登录
    Login: function Login(_ref, userInfo) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      return new _Promise(function (resolve, reject) {
        loginAPI(userInfo).then(function (res) {
          var data = res.data || data;
          if (!data.hasOwnProperty('companyList')) {
            commit('SET_AUTH', data);
            dispatch('GetUserInfo');
          }
          resolve(res);
        }).catch(function (error) {
          dispatch('LogOut');
          reject(error);
        });
      });
    },


    // 获取权限
    getAuth: function getAuth(_ref2) {
      var commit = _ref2.commit;

      return new _Promise(function (resolve, reject) {
        adminIndexAuthListAPI().then(function (response) {
          var data = response.data;
          Lockr.set('authList', data);
          data.wkFirstModel = data.firstModel;
          commit('SET_ALLAUTH', data);
          commit('SET_CRM', data.crm);
          commit('SET_BI', data.bi);
          commit('SET_MANAGE', data.manage);
          commit('SET_OA', data.oa);
          commit('SET_PROJECT', data.project);

          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },


    // 获取用户信息
    GetUserInfo: function GetUserInfo(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      return new _Promise(function (resolve, reject) {
        adminUsersReadAPI().then(function (response) {
          // 邮件信息 走之前的逻辑
          commit('SET_USERINFO', response.data);

          //response.data.serverUserInfo && request(response.data)

          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },


    // 登出
    LogOut: function LogOut(_ref4) {
      var commit = _ref4.commit;

      return new _Promise(function (resolve, reject) {
        logoutAPI().then(function () {
          /** flush 清空localStorage .rm('authKey') 按照key清除 */
          removeAuth();
          resetRouter();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }
};

export default user;